import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Divider, Tabs } from '@mantine/core';
import { IconSettings, IconPilcrow, IconCheckbox } from '@tabler/icons';
import { ContractContext, useAgreements } from '../../Service/Context/ContractContextV2';
import DocumentAgreements from '../../Molecules/Document/DocumentAgreements';
import DocumentHeadTemplate from '../DocumentHeadTemplate';
import { FooterGap } from '../Navigation/phone/InjectableFooter';
import ContractLayoutSection from './sections/ContractLayoutSection';
import ContractSignatureSection from './sections/ContractSignatureSection';
import ContractGeneralSection from './sections/ContractGeneralSection';
import ContractContentSection from './sections/ContractContentSection';
import ContractPdfSection from './sections/ContractPdfSection';

const Contract = () => {
  const { id: eventId } = useParams();
  const { loading, contract } = useContext(ContractContext);
  const { ...agreementsProps } = useAgreements();
  const { id, number } = contract ?? {};

  return (
    <Container p={0} pos="relative">
      <DocumentHeadTemplate
        entityType="contracts"
        entityId={contract ? contract.id.toString() : ''}
        title={loading ? 'Laden ...' : `Vertrag ${number}` || 'Vertrag'}
        previewUrl={`/events/${eventId}/contracts/${id}/preview`}
        entity={contract}
      />
      <Tabs
        styles={{
          tab: {
            '&[data-active]': {
              fontWeight: 'bolder',
            },
          },
        }}
        defaultValue="content"
      >
        <Tabs.List>
          <Tabs.Tab value="content" icon={<IconPilcrow size={14} />}>
            Inhalt
          </Tabs.Tab>
          <Tabs.Tab value="settings" icon={<IconSettings size={14} />}>
            Einstellungen
          </Tabs.Tab>
          <Tabs.Tab value="agreements" icon={<IconCheckbox size={14} />}>
            Einwilligungen
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="content" pt="xl">
          <ContractGeneralSection />
          <ContractContentSection />
          <FooterGap />
        </Tabs.Panel>
        <Tabs.Panel
          value="settings"
          pt="xs"
          sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'white' : 'black' })}
        >
          <ContractLayoutSection />
          <Divider my={30} />
          <ContractSignatureSection />
          <Divider my={30} />
          <ContractPdfSection />
          <FooterGap />
        </Tabs.Panel>
        <Tabs.Panel value="agreements" pt="xs">
          {contract && (
            <>
              <DocumentAgreements documentId={contract.id} {...agreementsProps} />
              <FooterGap />
            </>
          )}
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default Contract;
